import { createFileRoute } from "@tanstack/react-router";
import { JaziaLanding } from "@/components/landing/JaziaLanding";

export const Route = createFileRoute("/")({
  component: JaziaLanding,
});
